import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formWrap", "success", "pricingCheck"]

  async submit(event) {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)

    try {
      const res = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
      })
      if (!res.ok) throw new Error("submit failed")
      this.showSuccess()
    } catch (e) {
      alert("Odeslání selhalo, zkuste to prosím znovu nebo nám napište přímo na sonavosmikova@pressdent.cz.")
    }
  }

  showSuccess() {
    this.formWrapTarget.hidden = true
    this.successTarget.hidden = false
    this.successTarget.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  reset() {
    this.successTarget.hidden = true
    this.formWrapTarget.hidden = false
    this.element.querySelector("form")?.reset()
  }

  requestPricing() {
    if (this.hasPricingCheckTarget) this.pricingCheckTarget.checked = true
    this.element.querySelector("#cf-message")?.focus()
  }
}
